import gql from "graphql-tag";

export const tokenAuthenticateGql = gql`
  mutation TokenAuthenticate($input: AuthenticationInput!) {
    tokenAuthenticate(input: $input) {
      ... on Authentication {
        token
        verificationRequirementsStatus {
          idDocument {
            hasError
            verificationStatus
          }
          addressDocument {
            hasError
            verificationStatus
          }
          selfie {
            hasError
            verificationStatus
          }
          questionnaire {
            hasError
            verificationStatus
          }
          companyDocuments {
            hasError
            documents {
              verificationStatus
              documentType
            }
          }
        }
        user {
          id
          name
          email
          pendingEmail
          apiCompanyId
          phone
          nationality {
            name
            code
          }
          pendingPhone
          internalVerificationStatus
          personalVerificationStatus
          companyVerificationStatus
          currentVerificationPage
          apiCompanyId
          isEmailConfirmed
          isPhoneConfirmed
          hasBackupCodesSetup
          is2faEnabled
          avatarUrl
        }
      }

      ... on ResponseErrors {
        errors {
          message
          code
          displayMessage

          ... on InternalError {
            message
            code
            displayMessage
            context
          }

          ... on InvalidOtp {
            code
            message
            displayMessage
            field
            messageContext
            hasBackupCodesSetup
            isEmailConfirmed
            isPhoneConfirmed
            email
            phone
          }
        }
      }
    }
  }
`;
